export default "__VITE_ASSET__83f1b92a__"